export { default } from './MedicalProblemPopup';
